import { render, staticRenderFns } from "./maintain-project-edit.vue?vue&type=template&id=7a06bbe8&scoped=true"
import script from "./maintain-project-edit.vue?vue&type=script&lang=ts"
export * from "./maintain-project-edit.vue?vue&type=script&lang=ts"
import style0 from "./maintain-project-edit.vue?vue&type=style&index=0&id=7a06bbe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a06bbe8",
  null
  
)

export default component.exports